/**
 * WebRTC 관련 에러
 */
export const WEBRTC_ERROR_PATTERNS = [
  /**
   * Failed to execute 'addIceCandidate' on 'RTCPeerConnection': The RTCPeerConnection's signalingState is 'closed'.
   * chromium 자체 버그로 인한 오류
   * Sentry Issue: https://zep-us.sentry.io/issues/6146021243
   * Refs: https://issues.chromium.org/issues/40633682,
   * https://stackoverflow.com/questions/58908081/webrtc-getting-failed-to-execute-addicecandidate-on-rtcpeerconnection-error-on
   */
  "Failed to execute 'addIceCandidate' on 'RTCPeerConnection'",

  /**
   * NegotiationError가 unhandled rejection에 잡히는 케이스
   * unhandled rejection이긴 하지만, 이 에러가 발생했을 때 RoomEvent.Disconnected 이벤트가 발생하게 되어 있고,
   * RoomEvent.Disconnected 이벤트가 발생하면 브라우저 새로고침을 권유하는 에러 다이얼로그를 띄우게 되어 있습니다.
   * 즉, 유저에게 문제를 해결할 방법을 제공하고 있으므로, 이 에러는 무시해도 될 것 같습니다.
   * Ref: https://zep-us.slack.com/archives/C07SAR3VAUC/p1736213454424969
   */
  "Failed to execute 'setRemoteDescription' on 'RTCPeerConnection': The RTCPeerConnection's signalingState is 'closed'",

  /**
   * Sentry Discover: https://zep-us.sentry.io/discover/results/?dataset=errors&field=title&field=project&field=user.display&field=timestamp&name=All%20Errors&project=4505679612805120&query=LiveKit%20doesn%27t%20seem%20to%20be%20supported%20on%20this%20browser.%20Try%20to%20update%20your%20browser%20and%20make%20sure%20no%20browser%20extensions%20are%20disabling%20webRTC.&queryDataset=error-events&sort=-timestamp&statsPeriod=14d&yAxis=count%28%29
   * 발생률 자체가 높지 않고 minor 이슈라고 판단되어 노이즈를 줄이기 위해 무시합니다.
   */
  "LiveKit doesn't seem to be supported on this browser. Try to update your browser and make sure no browser extensions are disabling webRTC.",

  /**
   * 클라이언트가 의도적으로 연결을 종료할 때 발생하는 정상적인 동작
   * 브라우저 탭 닫기, 새로고침, 페이지 이동 시 LiveKit WebRTC 연결이 정상적으로 종료되면서 발생
   * Sentry Issue: https://zep-us.sentry.io/issues/6222618858 (PLAY-APP-57H)
   * 166,320번 발생했으나 실제 이슈가 아닌 정상적인 연결 종료 로그
   * PR: https://github.com/zep-us/zep-client/pull/1806
   */
  'Client initiated disconnect',
] as const;
